import { render, staticRenderFns } from "./EventLotto.vue?vue&type=template&id=b59e7f06&scoped=true"
import script from "./EventLotto.vue?vue&type=script&lang=js"
export * from "./EventLotto.vue?vue&type=script&lang=js"
import style0 from "./EventLotto.vue?vue&type=style&index=0&id=b59e7f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59e7f06",
  null
  
)

export default component.exports